/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-05-12 17:20:42
 * @FilePath: \crane-safety-manager\src\helpers\permission_helper.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import _ from 'lodash';

export const VEHICLES_VIEW = 'vehicles.view';
export const VEHICLES_CREATE = 'vehicles.create';
export const VEHICLES_UPDATE = 'vehicles.update';
export const VEHICLES_DELETE = 'vehicles.delete';
export const PROJECTS_VIEW = 'projects.view';
export const PROJECTS_CREATE = 'projects.create';
export const PROJECTS_UPDATE = 'projects.update';
export const PROJECTS_DELETE = 'projects.delete';
export const SITES_VIEW = 'sites.view';
export const SITES_CREATE = 'sites.create';
export const SITES_UPDATE = 'sites.update';
export const SITES_DELETE = 'sites.delete';
export const USERS_VIEW = 'users.view';
export const USERS_CREATE = 'users.create';
export const USERS_UPDATE = 'users.update';
export const USERS_DELETE = 'users.delete';
export const NEW_VIEW = 'new.view';
export const ALARM_LOG_VIEW = 'alarms.view';
export const POLES_VIEW = 'poles.view';
export const POLES_CREATE = 'poles.create';
export const POLES_UPDATE = 'poles.update';
export const POLES_DELETE = 'poles.delete';

const rolePermissions = {
    /**
     * 测试人员
     */
    SystemAdmin: [ALARM_LOG_VIEW,POLES_VIEW,POLES_CREATE,POLES_UPDATE,POLES_DELETE, NEW_VIEW, VEHICLES_VIEW, VEHICLES_CREATE, VEHICLES_UPDATE, VEHICLES_DELETE, PROJECTS_VIEW, PROJECTS_CREATE, PROJECTS_UPDATE, PROJECTS_DELETE, SITES_VIEW, SITES_CREATE, SITES_UPDATE, SITES_DELETE, USERS_VIEW, USERS_CREATE, USERS_UPDATE, USERS_DELETE],
    /**
     * 总监理
     */
    Admin: [NEW_VIEW, VEHICLES_VIEW, PROJECTS_VIEW, SITES_VIEW, USERS_VIEW, USERS_CREATE, USERS_UPDATE, USERS_DELETE],
    /**
     * 总管理员
     */
    Supervisor: [NEW_VIEW, VEHICLES_VIEW, PROJECTS_VIEW, PROJECTS_CREATE, PROJECTS_UPDATE, PROJECTS_DELETE,SITES_VIEW,USERS_VIEW, USERS_CREATE, USERS_UPDATE, USERS_DELETE],
    /**
     * 项目管理员
     */
    ProjectAdmin: [VEHICLES_VIEW, VEHICLES_CREATE, VEHICLES_UPDATE, VEHICLES_DELETE, SITES_VIEW, SITES_CREATE, SITES_UPDATE, SITES_DELETE, USERS_VIEW, USERS_CREATE, USERS_UPDATE, USERS_DELETE],
    /**
     * 设备管理员
     */
    ProjectSupervisor: [VEHICLES_VIEW]
};

export function hasPermission(role, permission) {
    if (_.isEmpty(role) || _.isEmpty(permission)) {
        return false;
    }

    const rPermissions = rolePermissions[role];
    if (_.isNil(rPermissions) || _.isEmpty(rPermissions) || !_.isArray(rPermissions)) {
        return false;
    }

    return rPermissions.includes(permission);
}
